<template>
  <div>
    <el-dialog
      title="发送邮件"
      center
      width="700px"
      :visible.sync="visible"
      @closed="onClosed"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form ref="form" :model="form" label-width="160px" size="mini">
        <el-form-item label="模板名称：">
          <label>{{ this.value.mailTemplate.mailTemplateName }}</label>
        </el-form-item>
        <el-form-item label="目标渠道：">
          <channel-selector
            placeholder="请选择"
            :disabled="this.value.channelId != 0"
            @ready="onChannelSelectorReady"
            @change="onChannelSelectorChange"
            ref="channelSelector"
          >
          </channel-selector>
        </el-form-item>
        <el-form-item label="目标渠道内全体玩家：">
          <el-switch
            @change="openIsToAll()"
            v-model="form.isToAll"
            active-color="#13ce66"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="玩家ID集合：" v-show="!form.isToAll">
          <el-input
            type="textarea"
            rows="10"
            v-model="form.uidList"
            placeholder="可放多个ID，每行放1个"
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item label="附件：">
          <mail-attachment
            v-for="item of form.attachments"
            :key="item.seq"
            :availableAttachments="availableAttachments"
            v-model="item.data"
            @remove="removeAttachment(item.seq)"
          ></mail-attachment>
          <el-button @click="addNewAttachment()" class="el-icon-plus"
            >添加</el-button
          >
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-s-promotion"
          @click="
            submit();
            openSendMailWarn();
          "
          >发送</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("../../util");

import MailAttachment from "./MailAttachment.vue";
import ChannelSelector from "@/components/ChannelSelector";

export default {
  data() {
    return {
      visible: true,
      form: {
        selectedChannelId: "",
        isToAll: false,
        uidList: "",
        attachments: [],
      },
      availableAttachments: [],
      attachmentSeq: 0,
    };
  },

  props: {
    value: Object,
  },

  components: {
    MailAttachment,
    ChannelSelector,
  },

  async created() {
    if (this.value.channelId != 0) {
      this.form.selectedChannelId = this.value.channelId;
    }

    await this.loadAvailableAttachments();
  },

  methods: {
    async onChannelSelectorReady() {
      this.$refs.channelSelector.channelId = this.form.selectedChannelId;
    },

    async onChannelSelectorChange(newChannelId, oldChannelId) {
      this.form.selectedChannelId = newChannelId;
    },

    //全服邮件提示
    openIsToAll(args) {
      if (this.form.isToAll) {
        this.$confirm("此操作将发送邮件至该渠道全服玩家, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$message({
              type: "success",
              message: "全服邮件!",
            });
          })
          .catch(() => {
            (this.form.isToAll = false),
              this.$message({
                type: "info",
                message: "取消成功",
              });
          });
      }
    },
    //发送邮件警示
    openSendMailWarn() {
      this.$notify({
        title: "警告",
        message: "已发送，请勿重复操作",
        type: "warning",
      });
    },

    /**
     * 查询可用附件集合
     */
    async loadAvailableAttachments() {
      let resData = (
        await axios.get(`${util.getBackendApiBase()}/v1/getAppendixList`, {
          headers: {
            token: util.getLoginUserToken(),
          },
        })
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      // 宝石
      if (resData.data.gemstoneList) {
        this.availableAttachments.push({
          label: "宝石",
          value: "宝石",
          children: (() => {
            let result = [];
            for (let e of resData.data.gemstoneList) {
              result.push({
                label: e.appendixName,
                value: e.appendixId,
              });
            }
            return result;
          })(),
        });
      }

      // 英雄
      if (resData.data.heroList) {
        this.availableAttachments.push({
          label: "英雄",
          value: "英雄",
          children: (() => {
            let result = [];
            for (let e of resData.data.heroList) {
              result.push({
                label: e.appendixName,
                value: e.appendixId,
              });
            }
            return result;
          })(),
        });
      }

      // 道具
      if (resData.data.itemList) {
        this.availableAttachments.push({
          label: "道具",
          value: "道具",
          children: (() => {
            let result = [];
            for (let e of resData.data.itemList) {
              result.push({
                label: e.appendixName,
                value: e.appendixId,
              });
            }
            return result;
          })(),
        });
      }

      // 装备
      if (resData.data.weaponList) {
        this.availableAttachments.push({
          label: "装备",
          value: "装备",
          children: (() => {
            let result = [];
            for (let e of resData.data.weaponList) {
              result.push({
                label: e.appendixName,
                value: e.appendixId,
              });
            }
            return result;
          })(),
        });
      }
    },

    /**
     * 增加一个附件
     */
    addNewAttachment() {
      this.form.attachments.push({
        seq: ++this.attachmentSeq,
        data: {
          valuesOfNodes: [],
          number: 1,
        },
      });
    },

    /**
     * 删除一个附件
     */
    removeAttachment(seq) {
      console.log("removeAttachment(), seq:", seq);
      for (let i = 0; i < this.form.attachments.length; i++) {
        if (this.form.attachments[i].seq == seq) {
          this.form.attachments.splice(i, 1);
          break;
        }
      }
    },

    /**
     * 提交表单
     */
    async submit() {
      // 必须选择渠道
      if (!this.form.selectedChannelId) {
        this.$message({
          message: "请选择渠道",
          type: "error",
        });
        return;
      }

      let uidList = [];
      if (!this.form.isToAll) {
        let parseResult = this.parseUidList();
        if (parseResult.err) {
          this.$message({
            message: parseResult.err,
            type: "error",
          });
          return;
        }

        uidList = parseResult.list;
      }

      let attachments = [];
      for (let e of this.form.attachments) {
        if (e.data.valuesOfNodes.length == 0) {
          this.$message({
            message: "请正确选择附件",
            type: "error",
          });
          return;
        }

        let id = e.data.valuesOfNodes[1];
        let num = e.data.number;
        attachments.push({
          id: id,
          num: num,
        });
      }

      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/sendMail`,
          {
            mailTemplateId: `${this.value.mailTemplate.mailTemplateId}`,
            channelId: parseInt(this.form.selectedChannelId),
            isProvideAll: this.form.isToAll,
            uidList: uidList,
            props: JSON.stringify(attachments),
          },
          {
            headers: {
              token: util.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: "发送失败",
          type: "error",
        });
        return;
      }

      this.$message({
        message: "发送成功",
        type: "success",
      });

      // 关闭当前对话框
      this.visible = false;
    },

    /**
     * 解析玩家ID集合
     *
     * @returns {list: [], err: "xxxx"}
     */
    parseUidList() {
      let list = [];

      let uidListStr = this.form.uidList.trim();
      if (uidListStr.length > 0) {
        let arr = uidListStr.split(/\s+/);
        for (let e of arr) {
          let uid = Number(e);
          if (isNaN(uid) || uid != parseInt(uid)) {
            return {
              list: [],
              err: "玩家ID格式错误",
            };
          }

          if (uid <= 0) {
            return {
              list: [],
              err: "玩家ID必须是正整数",
            };
          }

          list.push(uid);
        }
      }

      if (list.length == 0) {
        return {
          list: [],
          err: "请输入玩家ID",
        };
      }

      return {
        list: list,
      };
    },

    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },
  },
};
</script>